import setCssVar from "./setCssVar";

export function onLoadEvents(APP) {
  let previousViewportHeight = null;
  APP.user = {
    isTabbing: undefined,
  };

  const removeHrefFromEmptyOrHashedLinks = () => {
    const links = document.querySelectorAll("a[href=''], a[href='#']");
    links.forEach((link) => {
      link.removeAttribute("href");
    });
  }

  const setViewportHeightVariable = () => {
    if (previousViewportHeight === window.innerHeight) return;
    setCssVar(null, '--viewportHeight', `${window.innerHeight}px`);
    previousViewportHeight = window.innerHeight;
  }

  const buildModalLinks = () => {
    const links = document.querySelectorAll('#content a');
    for (const link of links) {
      if (link.getAttribute('href').includes('#form-')) {
        link.setAttribute('data-bs-toggle', 'modal');
        link.setAttribute('data-bs-target', link.getAttribute('href'));
      }
    }
  }

  const setupModalCloseFallback = () => {
    document.addEventListener('click', (event) => {
      const dismissTrigger = event.target.closest('[data-bs-dismiss="modal"]');
      if (!dismissTrigger) return;

      const modal = dismissTrigger.closest('.modal') || document.querySelector('.modal.show');
      if (!modal) return;

      event.preventDefault();

      const bootstrapModal = window.bootstrap?.Modal?.getOrCreateInstance(modal);

      if (bootstrapModal) {
        bootstrapModal.hide();
        return;
      }

      modal.classList.remove('show');
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('aria-modal');
      modal.removeAttribute('role');

      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');

      document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
    }, true);
  }

  // removeHrefFromEmptyOrHashedLinks();
  setViewportHeightVariable();
  buildModalLinks();
  setupModalCloseFallback();
  window.addEventListener('resize', setViewportHeightVariable);

  // if user is tabbing
  document.body.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    APP.user.isTabbing = true;
    document.body.classList.add('is-tabbing');
  });

  // if user is not tabbing
  document.body.addEventListener('mousemove', () => {
    if (!APP.user.isTabbing) return;
    APP.user.isTabbing = false;
    document.body.classList.remove('is-tabbing');
  });



}
